const html = require('choo/html');
const Component = require('choo/component');
const { SEND_UI_LANGUAGES, getLanguageLabel } = require('./sendLanguageOptions');

class LanguageSwitch extends Component {
  constructor(name, state, emit) {
    super(name);
    this.state = state;
    this.emit = emit;
  }

  toggleMenu(event) {
    event.preventDefault();
    event.stopPropagation();
    const menu = document.getElementById('langMenu');
    const isHidden = menu.classList.contains('hidden');

    if (isHidden) {
      menu.classList.remove('hidden');
      // Use a small timeout to allow display:block to take effect before opacity change
      requestAnimationFrame(() => {
        menu.classList.add('opacity-100');
        menu.classList.add('translate-y-0');
        menu.classList.remove('opacity-0');
        menu.classList.remove('-translate-y-2');
      });
      menu.focus();
    } else {
      this.closeMenu();
    }
  }

  closeMenu() {
    const menu = document.getElementById('langMenu');
    if (!menu) return;

    menu.classList.remove('opacity-100');
    menu.classList.remove('translate-y-0');
    menu.classList.add('opacity-0');
    menu.classList.add('-translate-y-2');

    // Wait for transition to finish before adding hidden
    setTimeout(() => {
      menu.classList.add('hidden');
    }, 200);
  }

  hideMenu(event) {
    // Check if the relatedTarget is within the menu to prevent closing when clicking items
    if (
      event.relatedTarget &&
      event.currentTarget.contains(event.relatedTarget)
    ) {
      return;
    }
    this.closeMenu();
  }

  setLanguage(event, lang) {
    event.preventDefault();
    event.stopPropagation();
    this.emit('setLanguage', lang);
    this.closeMenu();
  }

  update() {
    return true;
  }

  createElement() {
    const currentLang = this.state.locale;
    const translate = this.state.translate;
    const languages = SEND_UI_LANGUAGES;

    const found = languages.find(l => l.code === currentLang);
    const currentLabel = found
      ? getLanguageLabel(found.code)
      : translate('langFallback');

    return html`
      <div class="relative z-50 min-h-8 mr-2 md:mr-4 overflow-visible">
        <button
          class="flex items-center h-8 px-3 rounded border text-grey-80 border-grey-40 hover:border-blue-60 hover:text-blue-60 dark:text-grey-40 dark:border-grey-60 dark:hover:text-grey-30 focus:outline transition-all duration-200"
          onclick="${e => this.toggleMenu(e)}"
          title="${translate('langSwitchTitle')}"
        >
          <span class="mr-2 text-sm font-medium">${currentLabel}</span>
          <svg
            class="w-4 h-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            />
          </svg>
        </button>
        <ul
          id="langMenu"
          class="hidden absolute top-full right-0 mt-1 py-1 bg-white shadow-xl rounded whitespace-no-wrap outline-none z-[200] dark:bg-grey-80 border dark:border-grey-60 opacity-0 -translate-y-2 transition-all duration-200 ease-out max-h-96 overflow-y-auto"
          style="min-width: 140px"
          onblur="${e => this.hideMenu(e)}"
          tabindex="-1"
        >
          ${languages.map(lang => html`
            <li>
              <button
                class="block w-full text-left px-4 py-2 text-sm text-grey-80 dark:text-grey-30 hover:bg-blue-60 hover:text-white cursor-pointer focus:outline transition-colors duration-150 ${currentLang === lang.code ? 'font-bold bg-grey-10 dark:bg-grey-70' : ''}"
                onclick="${e => this.setLanguage(e, lang.code)}"
              >
                ${getLanguageLabel(lang.code)}
              </button>
            </li>
          `)}
        </ul>
      </div>
    `;
  }
}

module.exports = LanguageSwitch;
